/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Log_Toast_UpdatedInputs */

const vi_scl_log_toast_updated = /** @type {(inputs: Scl_Log_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu thay đổi`)
};

/**

* @param {Scl_Log_Toast_UpdatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_log_toast_updated = /** @type {((inputs?: Scl_Log_Toast_UpdatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Log_Toast_UpdatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_log_toast_updated(inputs)
});